import Layout from '../../../Components/Layout/Layout';
import { Card, Spinner } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { BiLogOutCircle } from 'react-icons/bi';
import { AiOutlineMail } from 'react-icons/ai';
import { CgProductHunt } from 'react-icons/cg';
import { CgCalendarDates } from 'react-icons/cg';
import { RiKeyLine } from 'react-icons/ri';
import { FiSmartphone } from 'react-icons/fi';
import { AiOutlineCamera } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { B2B_USER_FAILED } from '../../../Helpers/Constant';
import { imgUrl } from '../../../Helpers/Constant';
import { B2BAuthContext } from '../../../Context/AuthContex/B2BAuthContext';
import {
  useB2BProfileUpdate,
  useGetB2BProfile,
} from '../apiEndpoints/b2bBuyerSellerEndpoint';
import CommonContainer from '../../../Components/Common/CommonContainer';

const B2BProfile = () => {
  const location = useLocation();
  const { data } = useGetB2BProfile();
  const { id } = useParams();
  const {
    state: { b2bUser },
    dispatch: b2bAuthDispatch,
  } = B2BAuthContext();

  const { mutate, isPending } = useB2BProfileUpdate();
  const handleLogout = () => {
    localStorage.removeItem('toab_fair');
    b2bAuthDispatch?.({
      type: B2B_USER_FAILED,
    });
  };

  const handelImageUpdate = async (img: any) => {
    const data: any = {
      b2b_id: b2bUser.b2b_id,
    };
    const formData = new FormData();
    Object.keys(data).forEach((item) => {
      formData.append(item, data[item]);
    });
    formData.append('b2b_photo', img);
    mutate(formData);
  };

  return (
    <Layout
      pathName={
        data?.data.b2b_type === 'Seller'
          ? `Seller B2B Profile`
          : data?.data.b2b_type === 'Buyer'
          ? `Buyer B2B Profile`
          : `Buyer/Seller B2B Profile`
      }
      showHeader
    >
      <div>
        <CommonContainer>
          <Row>
            <Col xs={12} md={3}>
              <Row>
                <Col>
                  <Card className='profile-left-side'>
                    <div className='user-profile-header d-flex flex-column align-items-center text-center bg-light p-4 rounded shadow-sm'>
                      <div className='position-relative'>
                        <img
                          src={
                            !data?.data?.b2b_photo
                              ? '/blank-image.png'
                              : `${imgUrl}/${data?.data?.b2b_photo}`
                          }
                          height={150}
                          width={150}
                          alt='User Profile'
                          className='rounded-3 user-profile-img d-block  ms-0 ms-sm-4'
                          style={{ objectFit: 'cover' }}
                        />
                        <div className='position-absolute bottom-0 end-0 bg-white rounded-circle p-1 shadow'>
                          {isPending ? (
                            <Spinner
                              animation='border'
                              variant='primary'
                              size='sm'
                            />
                          ) : (
                            <label htmlFor='file' className='m-0'>
                              <AiOutlineCamera
                                size={25}
                                className='pointer text-primary'
                              />
                              <input
                                type='file'
                                id='file'
                                onChange={(e: any) =>
                                  handelImageUpdate(e?.target?.files[0])
                                }
                                hidden
                              />
                            </label>
                          )}
                        </div>
                      </div>
                      <div className='mt-3'>
                        <h4 className='fw-bold text-primary'>
                          {data?.data?.b2b_first_name}{' '}
                          {data?.data?.b2b_last_name}
                        </h4>
                        <div className='fw-light text-secondary mb-1'>
                          {data?.data?.b2b_organization}
                        </div>
                        <ul className='list-inline mb-0'>
                          <li className='list-inline-item d-flex align-items-center gap-2'>
                            <AiOutlineMail className='text-secondary' />
                            <span>{data?.data?.b2b_email}</span>
                          </li>
                          <li className='list-inline-item d-flex align-items-center gap-2 mt-2'>
                            <FiSmartphone className='text-secondary' />
                            <span>{data?.data?.b2b_phone}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>

              <div className='profile-left-side  ps-4 my-3 py-3'>
                <div>
                  {/* <Link
                    to='/b2b/register-event'
                    className={
                      location.pathname === `/b2b/register-event`
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2 '>
                      <CgCalendarDates />
                      <p>Registered Events</p>
                    </div>
                  </Link> */}
                  <Link
                    to='/b2b/invoice'
                    className={
                      location.pathname === `/b2b/invoice`
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2 mt-3'>
                      <CgCalendarDates />
                      <p>Invoices</p>
                    </div>
                  </Link>
                  <Link
                    to='/b2b/slot'
                    className={
                      location.pathname === `/b2b/slot`
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2 mt-3'>
                      <CgCalendarDates />
                      <p>My Available Slot</p>
                    </div>
                  </Link>
                  <Link
                    to='/b2b/meeting-request'
                    className={
                      location.pathname === `/b2b/meeting-request` ||
                      location.pathname === `/b2b/available-slot/${id}`
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2 mt-3'>
                      <CgCalendarDates />
                      <p>My Meeting Request</p>
                    </div>
                  </Link>
                  <Link
                    to={`/b2b/other-b2b-slot-list?type=B2B&user_id=${b2bUser.b2b_id}`}
                    className={
                      location.pathname === '/b2b/other-b2b-slot-list'
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2 mt-3'>
                      <CgCalendarDates />
                      <p>Received Meeting Request</p>
                    </div>
                  </Link>
                  <Link
                    to='/b2b/profile'
                    className={
                      location.pathname === `/b2b/profile`
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2 my-3'>
                      <CgProductHunt />
                      <p>Profile</p>
                    </div>
                  </Link>

                  <div className='d-flex align-items-center gap-2 pb-3'>
                    <Link
                      to='/b2b/change-password'
                      className={
                        location.pathname === '/visitor/change-password'
                          ? 'profile-left-side-link-active'
                          : 'profile-left-side-link'
                      }
                    >
                      <div className='d-flex align-items-center gap-2'>
                        <RiKeyLine />
                        <p>Change Password</p>
                      </div>
                    </Link>
                  </div>

                  <div
                    className='d-flex align-items-center gap-2 pb-3 pointer'
                    onClick={handleLogout}
                  >
                    <BiLogOutCircle />
                    <p>Logout</p>
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} md={9}>
              <div className='mt-5 mt-md-0'>
                <Outlet />
              </div>
            </Col>
          </Row>
        </CommonContainer>
      </div>
    </Layout>
  );
};

export default B2BProfile;
